import React, { Component } from "react";
import PropTypes from "prop-types";

import * as actions from "../../../redux/modules/actions";

import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel,
  ButtonGroup,
  Glyphicon
} from "react-bootstrap";
import renderHTML from "react-render-html";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Dialog from "react-bootstrap-dialog";
import { voucherActions } from "../../../redux/actions/voucherActions";
import {
  renderAlert,
  clearAlert,
  alertsActions
} from "../../../redux/actions/alertsActions";
import "../../../style/listPage.scss";

import Pagination from "react-paginating";
import moment from "moment";
import "../../../style/react-paginating.css";
import ReactHtmlParser from "react-html-parser";
import {aclUtil} from "../../util"

const history = createBrowserHistory();

class OrderHistory extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'ORDERS',
      userId: null,
      orderList: [],
      activePage: 1,
      totalRecords: 0,
      sending: true,
      searchString: "",
      limit: 25,
      search: "",
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      path: ["Home", "Order History"],
      links:['home','orders'],
      show: false,
      alert: false,
      orderby: "",
      direction: ""
    };

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    let formData = { page: this.state.activePage, limit: this.state.limit, user: 'admin' };
    if(this.props.match && this.props.match.params && this.props.match.params.userId){
      formData.userID = this.props.match.params.userId;
    }
    const {actions: { getOrderHistory }} = this.props;
    getOrderHistory(formData);
    if (this.props.error) {
      this.setState({ sending: false });
    }
  }

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });
    let formData = { page: page,limit: this.state.limit, user: 'admin'};
    if (this.state.direction !== "" && this.state.orderBy !== "") {
      formData.orderBy = this.state.orderBy;
      formData.direction = this.state.direction;
    } else if (this.state.searchString !== "") {
      formData.search = this.state.searchString;
    }

    if(this.props.match && this.props.match.params && this.props.match.params.userId){
      formData.userID = this.props.match.params.userId;
    }

    const {actions: { getOrderHistory }} = this.props;
    getOrderHistory(formData);
  };

  handleSearch = () => e => {
    const searchString = e.target.value;
    let formData = { page: 1,limit: this.state.limit, user: 'admin' };

    if (searchString.length > 0) {
      formData.search = searchString;
    }
    if(this.props.match && this.props.match.params && this.props.match.params.userID){
      formData.userID = this.props.match.params.userID;
    }
    const {actions: { getOrderHistory }} = this.props;
    getOrderHistory(formData);
    this.setState({ searchString: searchString });
  };

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    if (nextProps.orderList) {
      let resData = nextProps.orderList;
      let setPageCount = resData.total / resData.per_page;
      this.setState({
        orderList: resData.data,
        currentPage: resData.current_page,
        from: resData.from,
        last_page: resData.last_page,
        perPage: resData.per_page,
        to: resData.to,
        totalRecords: resData.total,
        pageCount: setPageCount
      });
    }
    if (nextProps.orderList || nextProps.error) {
      this.setState({ sending: false });
    }
  }


  handleShow() {
    this.setState({ show: true });
  }

  handleDismiss() {
    this.setState({ show: false });
  }


  stringUCWord(str) {
    if (str) {
      str = str.replace(/_/g, " ");
      let sText = str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
        return letter.toUpperCase();
      });
      return sText;
    }
  }

  render() {
    const {
      currentPage,
      totalRecords,
      perPage,
      pageCount,
      orderList
    } = this.state;

    let contentRow;
    if (!isEmpty(orderList)) {
      contentRow = orderList.map((dc, index) => (
        <tr key={dc.dealID+''+index}>
          <td>{dc.merchantName}</td>
          <td>{ReactHtmlParser(dc.dealText)}</td>
          <td>{localStorage.getItem('symbol')}{dc.amount_charged}</td>
          <td>{localStorage.getItem('symbol')}{(dc.store_credit_used) ? dc.store_credit_used : '0'}</td>
          <td>{moment(dc.placed_on).format("ll hh:mm A")}</td>
        </tr>
      ));
    }

    return (
      <div>
        {this.state.sending === true ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />

        <div className="col-lg-12 user-list list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">
              <div className="row">
                <div className="col-lg-8 col-md-4 col-sm-12">
                  <h4>Order History</h4>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" onKeyUp={this.handleSearch()} />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
              </div>
            </header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="row">
                <div className="col-lg-12">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th> Merchant </th>
                        <th> Offer </th>
                        <th> Amount Charged </th>
                        <th> Credit Used </th>
                        <th> Placed On </th>
                      </tr>
                    </thead>
                    <tbody>{contentRow}</tbody>
                  </table>
                  <div className="text-center">
                  <Pagination
                    total={totalRecords}
                    limit={perPage}
                    pageCount={5}
                    currentPage={currentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps
                    }) => (
                      <div className="pagination">
                        <button className="btn btn-default"
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          first
                        </button>

                        {hasPreviousPage && (
                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map(page => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666"
                            };
                          }
                          return (
                            <button className="btn btn-default"
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button className="btn btn-default"
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          last
                        </button>
                      </div>
                    )}
                  </Pagination>
                </div>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    sending: state.voucherReducer.sending,
    error: state.voucherReducer.error,
    orderList: state.voucherReducer.orderList,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...voucherActions,
        ...alertsActions
      },
      dispatch
    )
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrderHistory));



// WEBPACK FOOTER //
// ./src/app/views/admin/voucher/OrderHistory.js